<template>
    <div class="modal-overlay">
      <div class="modal-container modal-full-width">
        <div class="header-recibo nao-imprimir">
            <h2 class="titulo-pagina">Imprimir Chamada em Branco</h2>
            <div class="botoes">
                <b-button variant="secondary" class="btn-voltar" @click="cancel">
                    <i class="bi bi-arrow-left"></i> Voltar
                </b-button>
                
                <b-button 
                    :variant="isGeneratingPdf ? 'success' : 'danger'" 
                    class="btn-pdf" 
                    :disabled="!dataAula || isGeneratingPdf" 
                    @click="gerarPDF">
                    <i class="bi bi-file-earmark-pdf"></i>
                    <span v-if="isGeneratingPdf">Baixando</span>
                    <span v-else>Baixar</span>
                </b-button>

            </div>
        </div>

        <!-- Área a ser impressa / convertida em PDF -->
        <div ref="printContent" class="recibo-container print-area">

        <!-- Cabeçalho igual ao ImprimirRecibo -->
        <template v-if="dataAula">

        <div class="recibo-header" v-if="escola && escola.nome">
          <img v-if="$globalState?.logoPath" :src="$globalState.logoPath" alt="Logomarca" class="header-logo" />
          <div class="escola-info">
            <h4>{{ escola.nome }}</h4><p></p>
            <p>{{ escola.slogan }}</p>
            <p>
              {{ escola.endereco }}, {{ escola.numero }}
              <span v-if="escola.complemento && escola.complemento !== 'null'">, {{ escola.complemento }}</span>
              - {{ escola.bairro }}
            </p>
            <p>{{ escola.municipio }} - {{ escola.estado }}, CEP: {{ escola.cep }}</p>
            <p>
              <i class="bi bi-telephone"></i> {{ escola.telefone }}
              <i class="bi bi-whatsapp text-success"></i> {{ escola.whatsapp }}
            </p>
          </div>
        </div>
        </template>
  
          <!-- Cabeçalho interno com dados da turma -->
          <div class="chamada-header">
            <h6>
              Chamada - Turma: {{ turma.turma }} | {{ turma.dias }} | {{ turma.horario }} | {{ turma.instrutor }}
            </h6>
          </div>
          <div class="spacer"></div>
  
          <!-- Seleção da Data da Aula -->
          <div class="form-group">
            <label>Data da Aula <span class="required">*</span></label>
            <div class="date-input-wrapper">
              <Flatpickr
                v-model="dataAula"
                :config="dateOptions"
                class="form-control input-sm-height"
              />
            </div>
          </div>
  
          <!-- Tabela de Alunos Matriculados -->
          <div v-if="alunosMatriculadosLocal.length">
            <h5 class="section-title" style="color: inherit;">Alunos Matriculados</h5>
            <table class="table table-main">
              <colgroup>
                <col style="width: 5%;">
                <col style="width: 5%;">
                <col style="width: 20%;">
                <col style="width: 5%;">
                <col style="width: 23%;">
                <col style="width: 10%;">
                <col style="width: 15%;">
              </colgroup>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Matrícula</th>
                  <th>Aluno</th>
                  <th>Presença</th>
                  <th>Animal <span class="required">*</span></th>
                  <th>Supervisão</th>
                  <th>Observações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(aluno, index) in alunosMatriculadosLocal" :key="aluno.matricula_id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ aluno.matricula_id || aluno.matricula }}</td>
                  <td>
                    {{ aluno.aluno_nome }}
                    <span v-if="aluno.reposicao" style="color: blue;"> (Reposição)</span>
                  </td>
                  <!-- Checkbox vazio para Presença -->
                  <td>
                    <template v-if="!isAlunoBloqueado(aluno)">
                        <input type="checkbox" class="checkbox-print" />
                    </template>
                    <template v-else>&nbsp;</template>
                  </td>
                  <!-- Campo Animal em branco -->
                  <td>&nbsp;</td>
                  <!-- Checkbox vazio para Supervisão -->
                  <td>
                    <template v-if="!isAlunoBloqueado(aluno)">
                        <input type="checkbox" class="checkbox-print" />
                    </template>
                    <template v-else>&nbsp;</template>
                  </td>
                  <td>{{ aluno.observacoes || '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <!-- Tabela de Aula Experimental -->
          <div v-if="alunosExperimentaisLocal.length">
            <h5 class="section-title" style="color: green;">Aula Experimental</h5>
            <table class="table table-extra">
              <colgroup>
                <col style="width: 5%;">
                <col style="width: 28%;">
                <col style="width: 5%;">
                <col style="width: 23%;">
                <col style="width: 25%;">
              </colgroup>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Aluno</th>
                  <th>Presença</th>
                  <th>Animal <span class="required">*</span></th>
                  <th>Observações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(aluno, index) in alunosExperimentaisLocal" :key="aluno.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ aluno.aluno_nome }}</td>
                  <td><input type="checkbox" class="checkbox-print" /></td>
                  <td>&nbsp;</td>
                  <td>{{ aluno.observacoes || '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <!-- Tabela de Aula Avulsa -->
          <div v-if="alunosAvulsosLocal.length">
            <h5 class="section-title" style="color: orange;">Aula Avulsa</h5>
            <table class="table table-extra">
              <colgroup>
                <col style="width: 5%;">
                <col style="width: 28%;">
                <col style="width: 5%;">
                <col style="width: 23%;">
                <col style="width: 25%;">
              </colgroup>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Aluno</th>
                  <th>Presença</th>
                  <th>Animal <span class="required">*</span></th>
                  <th>Observações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(aluno, index) in alunosAvulsosLocal" :key="aluno.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ aluno.aluno_nome }}</td>
                  <td><input type="checkbox" class="checkbox-print" /></td>
                  <td>&nbsp;</td>
                  <td>{{ aluno.observacoes || '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <template v-if="dataAula">
            <!-- Espaços para Registro de Quedas e Registro de Ressalvas -->
            <div class="registro-container">
            <div class="registro-box">
                <h5>Registro de Quedas</h5>
                <div class="box-lines">
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                </div>
            </div>
            <div class="registro-box">
                <h5>Registro de Ressalvas</h5>
                <div class="box-lines">
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                </div>
            </div>
            </div>
          </template>

        </div>
  
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, watch, onMounted } from 'vue';
  import axios from '@/services/axios';
  import Flatpickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
  import jsPDF from 'jspdf';
  import html2canvas from 'html2canvas';
  import { BButton } from "bootstrap-vue-next";

  
  const props = defineProps({
    turma: { type: Object, required: true }
  });
  const emit = defineEmits(['cancelar']);
  
  const dataAula = ref('');
  const alunosMatriculadosLocal = ref([]);
  const alunosExperimentaisLocal = ref([]);
  const alunosAvulsosLocal = ref([]);
  
  // Inicializa o objeto escola com valores padrão para evitar erro na renderização
  const escola = ref({
    nome: "",
    cnpj: "",
    endereco: "",
    numero: "",
    complemento: "",
    bairro: "",
    slogan: "",
    municipio: "",
    estado: "",
    cep: "",
    telefone: "",
    whatsapp: ""
  });
  
  // Função para carregar os dados da escola via API
  const carregarEscola = async () => {
    try {
      const empresaResponse = await axios.get(`configuracoes/empresa`);
      const empresa = empresaResponse.data;
      
      let municipioNome = "Cidade não informada";
      let estadoSigla = "UF";
      if (empresa.estado_cod) {
        try {
          const estadosResponse = await axios.get(`/localidades/estados`);
          const estado = estadosResponse.data.find(e => e.id === empresa.estado_cod);
          estadoSigla = estado ? estado.sigla : estadoSigla;
          if (empresa.municipio_cod) {
            const municipiosResponse = await axios.get(`/localidades/municipios/${empresa.estado_cod}`);
            const municipio = municipiosResponse.data.find(m => Number(m.id) === Number(empresa.municipio_cod));
            municipioNome = municipio ? municipio.nome : municipioNome;
          }
        } catch (error) {
          console.warn("Erro ao carregar estado e município:", error);
        }
      }
      escola.value = {
        nome: empresa.razao_social || "Nome da Escola",
        cnpj: empresa.cnpj || "00.000.000/0001-00",
        endereco: empresa.endereco || "Endereço não informado",
        numero: empresa.numero || "",
        complemento: empresa.complemento || "",
        bairro: empresa.bairro || "",
        slogan: empresa.slogan || "",
        municipio: municipioNome,
        estado: estadoSigla,
        cep: empresa.cep || "00000-000",
        telefone: empresa.telefone1 || "",
        whatsapp: empresa.whatsapp_url || ""
      };
    } catch (error) {
      console.error("Erro ao carregar dados da empresa:", error);
    }
  };
  
  function isAlunoBloqueado(aluno) {
    if (!aluno.observacoes) return false;
    const obs = aluno.observacoes.toLowerCase();
    return obs.includes('falta avisada') || obs.includes('matrícula trancada');
  }


  // Carrega os dados da escola assim que o componente for montado
  onMounted(async () => {
    await carregarEscola();
  });
  
  // Função para carregar os dados da aula (alunos)
  const carregarDadosAula = async (dataSelecionada) => {
    try {
      const formattedDate = new Date(dataSelecionada).toISOString().split('T')[0];
      const params = {
        data: formattedDate,
        turma_id: props.turma.turma,
        dia_semana: props.turma.dias,
        horario: props.turma.horario
      };
      const response = await axios.get(`/operacional/turmas-instrutor/detalhes`, { params });
      const matriculados = response.data.matriculados.map(a => ({
        ...a,
        observacoes: a.observacao || a.observacoes || ''
      }));
      const reposicao = response.data.reposicao.map(a => ({
        ...a,
        observacoes: a.observacao || a.observacoes || ''
      }));
      alunosMatriculadosLocal.value = [...matriculados, ...reposicao];
      alunosExperimentaisLocal.value = response.data.experimentais.map(a => ({
        ...a,
        observacoes: a.observacao || a.observacoes || ''
      }));
      alunosAvulsosLocal.value = response.data.avulsos.map(a => ({
        ...a,
        observacoes: a.observacao || a.observacoes || ''
      }));
    } catch (error) {
      console.error("Erro ao carregar os dados:", error);
    }
  };
  
  // Watch para carregar os dados da aula quando a data for definida
  watch(dataAula, (newDate) => {
    if (newDate) {
      carregarDadosAula(newDate);
    }
  });
  
  const allowedWeekDay = convertDiaSemana(props.turma.dias) || 0;
  const dateOptions = {
    dateFormat: "Y-m-d",
    altInput: true,
    altFormat: "d/m/Y",
    locale: Portuguese,
    enable: [
      function(date) {
        return date.getDay() === allowedWeekDay;
      }
    ]
  };
  
  function convertDiaSemana(dia) {
    const dias = {
      'domingo': 0,
      'segunda-feira': 1,
      'terça-feira': 2,
      'quarta-feira': 3,
      'quinta-feira': 4,
      'sexta-feira': 5,
      'sábado': 6
    };
    return dias[dia.toLowerCase()] ?? null;
  }
  
  // Função para fechar o modal
  const cancel = () => {
    emit('cancelar');
  };
  
  const isGeneratingPdf = ref(false);

  // Função para gerar o PDF
  const gerarPDF = async () => {
    isGeneratingPdf.value = true;
    const printElement = document.querySelector('.print-area');
    try {
        const canvas = await html2canvas(printElement, {
        scale: 2,
        useCORS: true
        });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const margin = 10;
        const pdfWidth = pdf.internal.pageSize.getWidth() - margin * 2;
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", margin, margin, pdfWidth, imgHeight);
        pdf.save(`chamada-${props.turma.turma}-${dataAula.value}.pdf`);
    } catch (error) {
        console.error("Erro ao gerar PDF:", error);
    } finally {
        isGeneratingPdf.value = false;
    }
  };
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .modal-container {
    background: #fff;
    width: 100%;
    max-width: 800px;
    max-height: 90%;
    overflow-y: auto;
    margin: 0 auto;
    border-radius: 0;
  }
  
  /* Cabeçalho do Recibo (igual ao ImprimirRecibo) */
  .recibo-header {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;
  }
  .header-logo {
    height: 60px;
    margin-right: 20px;
  }
  .escola-info {
    text-align: right;
    font-size: 12px;
    line-height: 1.2;
  }
  
  /* Área de impressão */
  .recibo-container {
    max-width: 800px;
    margin: auto;
    background: white;
    padding: 20px;
  }
  .spacer {
    margin-bottom: 20px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  .input-sm-height {
    height: 34px;
  }
  .date-input-wrapper {
    width: 300px;
  }
  
  .table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 15px;
  }
  .table th,
  .table td {
    border: 1px solid #ddd;
    padding: 8px;
    vertical-align: middle;
  }
  .table th {
    background: #f2f2f2;
  }
  
  .checkbox-print {
    width: 14px;
    height: 14px;
    margin: 0 auto;                /* centraliza dentro da célula */
    display: block;
    background-color: #fff;        /* fundo branco */
    border: 1px solid #000;        /* borda preta */
    accent-color: #000;            /* cor do check, para navegadores compatíveis */
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    }
  
  .section-title {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  .modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: 15px;
  }
  
  .nao-imprimir {
    display: block;
  }
  @media print {
    .nao-imprimir {
      display: none !important;
    }
    .modal-container {
      box-shadow: none;
    }
    body {
      margin: 10mm;
    }
  }

  .header-chamada {
  display: flex;
  justify-content: space-between; /* Alinha o título à esquerda e os botões à direita */
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #ddd; /* Linha separadora */
  margin-bottom: 20px; /* Espaço entre o header e o recibo */
}

.botoes {
    display: flex;
    align-items: center; /* 🔹 Garante que ambos os botões fiquem alinhados verticalmente */
    justify-content: flex-end; /* 🔹 Alinha os botões à direita */
    gap: 10px; /* 🔹 Mantém um espaçamento entre os botões */
  }


.btn-voltar {
  width: 70px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px; /* 🔹 Reduz o tamanho do texto */
  padding: 4px 8px; /* 🔹 Ajusta o preenchimento para reduzir o tamanho do botão */
  height: 30px; /* 🔹 Define uma altura menor */
}

.btn-pdf {
  width: 70px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px; /* 🔹 Reduz o tamanho do texto */
  padding: 4px 8px; /* 🔹 Ajusta o preenchimento para reduzir o tamanho do botão */
  height: 30px; /* 🔹 Define uma altura menor */
}


  .botoes .btn-imprimir {
  width: 33px;  /* ✅ Mesmo tamanho da altura do botão Voltar */
  height: 33px; /* ✅ Altura igual à largura, tornando-o quadrado */
  padding: 6px;
  border-radius: 6px; /* 🔹 Ajuste se quiser cantos levemente arredondados */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto; /* ✅ Move o botão para a direita */

}

.botoes .btn-imprimir i {
  font-size: 18px; /* Ajuste do ícone dentro do botão */
}

.recibo-container {
    max-width: 800px;
    margin: auto;
    background: white;
    padding: 20px;
    border: none
  }
  .recibo-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .logo {
    width: 80px;
  }
  .escola-info {
    text-align: center;
    margin: 0; /* Remove as margens verticais */
    line-height: 0; /* ✅ Reduz o espaçamento entre as linhas */
    font-size: 12px; /* ✅ Ajusta o tamanho da fonte */
  } 
  .recibo-title {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 20px;
    font-weight: bold;
  }

  .botoes {
    display: flex;
    align-items: center; /* 🔹 Garante que ambos os botões fiquem alinhados verticalmente */
    justify-content: flex-end; /* 🔹 Alinha os botões à direita */
    gap: 10px; /* 🔹 Mantém um espaçamento entre os botões */
  }


  .btn-voltar {
  width: 70px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px; /* 🔹 Reduz o tamanho do texto */
  padding: 4px 8px; /* 🔹 Ajusta o preenchimento para reduzir o tamanho do botão */
  height: 30px; /* 🔹 Define uma altura menor */
}

.btn-pdf {
  width: 70px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px; /* 🔹 Reduz o tamanho do texto */
  padding: 4px 8px; /* 🔹 Ajusta o preenchimento para reduzir o tamanho do botão */
  height: 30px; /* 🔹 Define uma altura menor */
}


  .botoes .btn-imprimir {
  width: 33px;  /* ✅ Mesmo tamanho da altura do botão Voltar */
  height: 33px; /* ✅ Altura igual à largura, tornando-o quadrado */
  padding: 6px;
  border-radius: 6px; /* 🔹 Ajuste se quiser cantos levemente arredondados */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto; /* ✅ Move o botão para a direita */

}

.botoes .btn-imprimir i {
  font-size: 18px; /* Ajuste do ícone dentro do botão */
}

  .header-logo {
  height: 60px;
}

.bi-telephone, .bi-whatsapp {
  margin-right: 2px;
  margin-left: 10px;
}

.recibo-texto {
  font-size: 14px;
  margin-top: 40px;
  margin-bottom: 30px;
}

.header-recibo {
  display: flex;
  justify-content: space-between; /* Alinha o título à esquerda e os botões à direita */
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #ddd; /* Linha separadora */
  margin-bottom: 20px; /* Espaço entre o header e o recibo */
}

.titulo-pagina {
  font-size: 20px;
  font-weight: bold;
  color: #444;
}

.botoes {
  display: flex;
  flex-direction: column; /* 🔹 Botões em coluna (um abaixo do outro) */
  gap: 8px; /* 🔹 Espaço entre os botões */
}

/* Espaço para Registro de Quedas e Ressalvas */
.registro-container {
  width: 100%;            /* garante ocupar toda a largura */
  display: flex;          /* boxes lado a lado */
  gap: 10px;              /* espaçamento horizontal entre os boxes */
  margin-top: 15px;       /* espaço acima (combine com a tabela) */
}

.registro-box {
  flex: 1;                /* cada box ocupa metade da largura */
  border: 1px solid #ddd;
  padding: 10px;
  min-height: 100px;       /* espaço para ~3 linhas */
  box-sizing: border-box; /* garante que padding não ultrapasse a largura */
}
.registro-box h5 {
  margin-top: 0;
  text-align: left;
  font-size: 1rem;
}

.table-main thead th:nth-child(4),
.table-main tbody td:nth-child(4),
.table-main thead th:nth-child(6),
.table-main tbody td:nth-child(6) {
  text-align: center;
}

.table-extra thead th:nth-child(3),
.table-extra tbody td:nth-child(3),
.table-extra thead th:nth-child(4),
.table-extra tbody td:nth-child(4) {
  text-align: center;
}

  </style>
  